var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("apexchart", {
        attrs: {
          height: "300",
          options: {
            grid: {
              show: true,
            },
            fill: {
              type: "solid",
            },
            dataLabels: {
              enabled: false,
            },
            chart: {
              toolbar: {
                show: false,
              },
              dropShadow: {
                enabled: true,
                color: "#000",
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2,
              },
            },
            stroke: {
              curve: "smooth",
              width: 4,
            },
            legend: {
              show: true,
            },
            xaxis: {
              categories: _vm.chartData.map((e) => e.date),
              labels: {
                show: true,
              },
            },
            yaxis: {
              min: 0,
              max: 100,
              tickAmount: 5,
              labels: {
                show: true,
              },
            },
            colors: ["#228cbd", "#f38c68"],
          },
          series: [
            {
              name: "Leads",
              data: _vm.chartData
                .map((e) => e.report.filter((data) => data.key == "leads"))
                .flat()
                .map((e) => e.value),
              type: "area",
            },
            {
              name: "System",
              data: _vm.chartData
                .map((e) => e.report.filter((data) => data.key == "leads"))
                .flat()
                .map((e) => e.system_median),
              type: "line",
            },
          ],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }